import DemoAddressesTableItem from './DemoAddressesTableItem'

export default DemoAddressesTableItem
